import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "./axiosConfig";

export default function LoginClient() {
  const navigate = useNavigate();

  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!phone || phone.trim().length < 8) {
      setError("Numéro de téléphone invalide");
      return;
    }

    if (!password || password.length < 4) {
      setError("Mot de passe trop court");
      return;
    }

    try {
      setLoading(true);

      const res = await api.post("/users/login", {
        phone: phone.trim(),
        password,
      });

      if (res.data?.ok) {
        // 🔐 Session simple (MVP)
        localStorage.setItem("customerPhone", phone.trim());
        navigate("/compte");
      } else {
        setError("Connexion impossible");
      }
    } catch (err) {
      setError(
        err?.response?.data?.error || "Impossible de se connecter"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen px-6 bg-gray-50">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-md p-6 bg-white shadow rounded-2xl"
      >
        <h1 className="mb-2 text-2xl font-bold">Mon compte</h1>
        <p className="mb-6 text-sm text-gray-500">
          Connectez-vous avec votre numéro et votre mot de passe
        </p>

        {/* TÉLÉPHONE */}
        <input
          type="tel"
          placeholder="Numéro de téléphone"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className="w-full px-4 py-3 mb-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-[#f34141]"
        />

        {/* MOT DE PASSE */}
        <input
          type="password"
          placeholder="Mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full px-4 py-3 mb-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-[#f34141]"
        />

        {error && (
          <p className="mb-3 text-sm text-red-500">{error}</p>
        )}

        <button
          type="submit"
          disabled={loading}
          className="w-full py-3 font-semibold text-white bg-[#f34141] rounded-xl disabled:opacity-60"
        >
          {loading ? "Connexion..." : "Accéder à mon compte"}
        </button>

        <p className="mt-4 text-xs text-center text-gray-400">
          Première connexion ? Votre compte sera créé automatiquement.
        </p>
      </form>
    </div>
  );
}